import React, { useState } from "react";
import { Trans } from "react-i18next";
import "../styles/components/Gender.scss";
import ValidationError from "./ValidationError";

const Gender = (props: any) => {
  let onChangeValue = (event: any) => {
    props.onChange(event);
  };

  return (
    <>
      <div className="" onClick={onChangeValue} id="gender">
        <label className="label-1">
          <Trans i18nKey={"gender"}></Trans>{" "}
          {props.mandate && <span className="mandetory">*</span>}
        </label>
        <div
          className={`genderContainer ms-1 gender mt-2 ${
            props?.disabled === undefined ? false : !props.disabled && "rem-m"
          }`}
        >
          <input
            type={"radio"}
            id="female"
            value={"female"}
            name="gender"
            defaultChecked={props.defaultSelected === "female"}
            disabled={props?.disabled === undefined ? false : !props.disabled}
          />
          <label htmlFor="female">
            <Trans i18nKey={"female"}></Trans>
          </label>
          <input
            type={"radio"}
            id="male"
            value={"male"}
            name="gender"
            data-testid="male"
            defaultChecked={props.defaultSelected === "male"}
            disabled={props?.disabled === undefined ? false : !props.disabled}
          />
          <label htmlFor="male">
            <Trans i18nKey={"male"}></Trans>
          </label>
          <input
            type={"radio"}
            id="other"
            value={"other"}
            name="gender"
            defaultChecked={props.defaultSelected === "other"}
            disabled={props?.disabled === undefined ? false : !props.disabled}
          />
          <label htmlFor="other">
            <Trans i18nKey={"other"}></Trans>
          </label>
        </div>
      </div>
      <ValidationError error_key={props?.error} />
    </>
  );
};

export default Gender;
